import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatGrid = createCustomElementWrapper('kat-grid', 'KatGrid', {
    'colsL': 'cols-l',
    'colsM': 'cols-m',
    'colsS': 'cols-s',
    'colsXl': 'cols-xl',
    'colsXxl': 'cols-xxl',
    'verticalList': 'vertical-list',
}, {});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/grid.js
// module id = 1255
// module chunks = 0